import { RegexEditor } from '../utils/regex_editor'

const _text =
  /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+/=?_`{|}~-]+@)|[\s\S]*?(?:(?=[\\<![`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+/=?_`{|}~-](?=[a-zA-Z0-9.!#$%&'*+/=?_`{|}~-]+@)))/

export const text = new RegexEditor(_text)
  .replace('\\b_', '\\b_| {2,}\\n')
  .replace(/\{2,\}/g, '*')
  .getRegex()
